import React, { useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import { motion as m, useAnimation, useInView } from "framer-motion";
import { product_lists } from "../constants";
import Accordion from "../ui/accordioncards";
import PageFrames from "../ui/pageframes";

const Products = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const mainControls = useAnimation();

  useEffect(() => {
    if (isInView) {
      mainControls.start("visible");
    }
  }, [isInView]);
  return (
    <PageFrames id="products">
      <div className="flex flex-col px-4 gap-2 items-center">
        <div className="flex flex-col md:flex-row items-center md:gap-4 text-[31px] text-center">
          <Icon
            icon="icon-park-outline:ad-product"
            className="text-[#002F6C]"
          />
          <h1>Products We Sell</h1>
        </div>
        <p className="accent-text text-center">
          Premium tech hardware and security solutions from trusted brands.
        </p>
      </div>
      <div className="flex flex-col w-full lg:max-w-[80%] gap-6 px-4">
        {product_lists.map((item) => (
          <Accordion data={item} key={item.id} />
        ))}
      </div>
    </PageFrames>
  );
};

export default Products;
